/**
 * @module  Experience/Shared-Browse
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/**
 * Constants for minimum selected number
 */
export const MIN_SELECTED_NUMBER_CONSTANTS = {
  MIN_SELECTED_NUMBER: 2,
  ACCESSORY_LIMIT: 10,
  EPIN_LIMIT: 15,
  ONE: 1,
};
/**
 * Constants for shared browse constants
 */
export const SHARED_BROWSE_CONSTANTS = {
  HTTP_URL: 'http(s?)://',
  changeZipState: 'CHANGE_ZIP',
  changeCreditLevelState: 'CHANGE_CREDIT_LEVEL',
  changeBillingState: 'CHANGE_BILLING',
  creditLevelChanged: 'Credit Level Changed',
  zipCodeChanged: 'Zip Code Changed',
  billingTypeChanged: 'Billing Type Changed',
  excellentCreditAPIMap: 'GOOD',
  avarageCreditAPIMap: 'BUILDING',
  buildingCreditAPIMap: 'NONE',
  prepaidAPIMap: 'PREPAID',
  postpaidAPIMap: 'POSTPAID',
  touristPlan: 'TOURIST PLAN',
  fullPriceOption: 'FRP',
  DEFAULT: 'DEFAULT',
  SHARED_BROWSE_MODULE: 'Shared Browse Module',
  NEW_LINE_ADDED: 'tempTileId',
  BROWSE_PLANS_PHONE_DETAILS: 'plan-detail',
  MEXICO_CANADA_SERVICE: 'AO_CMCAXU_PRE',
  SIXTY_EIGHT: '68',
  EMPTY_STRING: '',
  DECIMAL: '.',
  GOOD: 'GOOD',
  BUILDING: 'BUILDING',
  EIP: 'EIP',
  POSITIVE: '+',
  MONTHLY_INSTALLMENTS: 'Monthly Installments',
  ONE: '1',
  EXCELLENT_CREDIT: 'EXCELLENT_CREDIT',
  FRP: 'FRP',
  FRPWITHSERVICE: 'FRPWITHSERVICE',
  PAY_IN_FULL: 'Pay in Full',
  CONFLICT: 'CONFLICT',
  HARDCONFLICT: 'HARDCONFLICT',
  SOFTCONFLICT: 'SOFTCONFLICT',
  ANON: 'ANON',
  POSTPAID: 'postpaid',
  VOUCHER: 'VOUCHER',
  FINANCIAL: 'FINANCIAL',
  ACCESSORY: 'Accessory',
  DEVICE: 'device',
  NONLINEITEM: 'nonLineItem_',
  ERROR_100: '100',
  WARNING: 'WARNING',
  PORT_PROTECTION_PRE_OFFERCODE: 'AO_PORT_PROTECTION_PRE',
  CONNECT_BY_TMOBILE: 'connect-by-t-mobile',
  TMOBILE_PREPAID_PLAN: 't-mobile-prepaid-plans',
  MOBILE_INTERNET_PLAN: 'mobile-internet',
  UNDEFINED: 'undefined',
  TMOBILE_PREPAID_PLAN_HEADING: 'T-Mobile Unlimited rate plans.',
  CONNECT_BY_TMOBILE_HEADING: 'Connect by T-Mobile',
  TMO_PREPAID_CORE_OFFER_FAMILY_NAME: 'TMOPREPAIDV2',
  CONNECT_BY_TMO_CORE_OFFER_FAMILY_NAME: 'CONNECTBYTMO',
  MOBILE_INTERNET_CORE_OFFER_FAMILY_NAME: 'SCMIV2_NA',
};

export const PLAN_FAMILY_ROUTES_CONSTANTS = {
  BROWSE_PLANS_PHONE: '/browse-plans-phone',
  PLAN_DETAIL: '/plan-detail',
  BROWSE_PLANS_TABLET: '/browse-plans-tablet',
};

/**
 * Constants for channelType
 */
export const CHANNEL_CONST = {
  retail: 'retail',
  care: 'care',
  web: 'web',
  nrd: 'nrd',
};

/**
 * Enum values for credit levels
 */
export enum CreditLevelEnum {
  EXCELLENT_CREDIT,
  AVERAGE_CREDIT,
  BUILDING_CREDIT,
}

/**
 * Enum values for billing type
 */
export enum BillingTypeEnum {
  PREPAID,
  POSTPAID,
}

export enum PricingOptions {
  FRP,
  EIP,
  withoutservice,
  withservice,
}

export const SHARED_BROWSE_COMPONENTS = {
  SHARED_BROWSE_MODULE: 'SharedBrowseModule',
  ACCESORIES_CAROUSEL_SERVICE: 'AccessoriesService',
  SERVICE_BLADE_SERVICE: 'ServiceBladeService',
  SHARED_BROWSE_SERVICE: 'SharedBrowseService',
  CHANGE_ENTRY: 'ChangeEntryComponent',
  CREDIT: 'CreditComponent',
  DEVICE_ERROR_MODAL: 'DeviceErrorModalComponent',
  EIP_PRICE: 'EipPriceComponent',
  ENTRY_MODAL: 'EntryModalComponent',
  FRP_PRICE: 'FrpPriceComponent',
  PDP_PRODUCT_PRICE: 'PdpProductPriceComponent',
  PLAN_FAMILY: 'PlanFamilyComponent',
  PLAN_FAMILY_DIGITAL: 'PlanFamilyDigitalComponent',
  PLAN_TYPE: 'PlanTypeComponent',
  PRODUCT_CAROUSEL: 'ProductCarouselComponent',
  PRODUCT_PRICE: 'ProductPriceComponent',
  SERVICE_BLADE: 'ServiceBladeComponet',
  SERVICE_ENTRY: 'ServiceEntryComponent',
  ZIP_CODE: 'ZipCodeValidationComponent',
  PLAN_FAMILY_MODULE: 'PlanFamilyModule',
  PLAN_SUB_TITLE: 'PlanSubTitleComponent',
};

export const SERVICES_AND_PLANS = {
  GRANDFATHERED: 'GRANDFATHERED',
  ADD: 'ADD',
  RETAIN: 'RETAIN',
  CPS: 'CPS',
};

export const DEVICE_ERROR_MODAL = {
  CART: '/cart',
  PRODUCT_SELECTOR: '/product-selector/setup',
};

export const CONNECT_BY_TMOBILE_DURATION = {
  ONE_MONTH: '1',
  SIX_MONTH: '6',
  TWELVE_MONTH: '12',
  TWENTY_FOUR: '24',
};

export const ZIP_CODE_CONSTANTS = {
  ZIP_CODE_KEY: 'cachedZipCode',
  EXPIRATION_KEY: 'zipCodeExpiration',
  CACHE_HOURS: 24,
};
export const PLAN_PROMOTION_HEADER = {
  PLAN_PROMOTION_HEADER_MODULE: 'PlanPromotionHeaderModule',
  PLAN_PROMOTION_HEADER_COMPONENT: 'PlanPromotionHeaderComponent',
  PROMOTION_TEXT_MAX_LENGTH: 38,
};
